export type SandboxBreakdownClass = {
    key: string;
    title: string;
    description: string;
    has_assignment: boolean;
    is_free_preview: boolean;
};

export function emptyBreakdownClass(index = 0): SandboxBreakdownClass {
    return {
        key: `new-${Date.now()}-${index}`,
        title: '',
        description: '',
        has_assignment: false,
        is_free_preview: index === 0,
    };
}

/** Curriculum modules are derived from the class breakdown, not typed separately. */
export function extractSandboxModulesFromBreakdown(classes: SandboxBreakdownClass[]) {
    const lessons = classes
        .map((row, i) => ({
            title: row.title.trim(),
            description: (row.description || '').trim(),
            order: i,
            has_assignment: Boolean(row.has_assignment),
            is_free_preview: Boolean(row.is_free_preview),
        }))
        .filter(lesson => lesson.title);
    if (!lessons.length) return [];
    return [{ title: 'Curriculum', order: 0, lessons }];
}
